export default class WebSocketConnection {
    constructor(url, protocols=null, options={maxReconnections: 15}) {
        this.url = url;
        this.protocols = protocols;

        this.messageCallback = null;
        this.errorCallback = null;
        this.openCallback = null;
        this.closeCallback = null;
        this.reconnectAttempt = 0;
        this.maxReconnections = options.maxReconnections;
        this.stopReconnections = false;
        this.socket = null;
    }

    connect() {
        console.log(`Opening connection to ${this.url}`);

        this.stopReconnections = this.maxReconnections === 0;
        this.socket = new WebSocket(this.url, this.protocols);

        this.socket.onopen = () => {
            console.log(`Connected to ${this.url}`);
            this.reconnectAttempt = 0;
            if(this.openCallback) {
                this.openCallback()
            }
        }

        this.socket.onclose = (event) => {
            console.log(`Connection to ${this.url} closed with code ${event.code}`)
            const willReconnect = event.code !== 1000 && event.code !== 1001 && ++this.reconnectAttempt < this.maxReconnections && !this.stopReconnections;

            if(willReconnect) {
                this.reconnect()
            } else if(this.closeCallback) {
                this.closeCallback(event)
                this.socket = null
            }
        }

        this.socket.onerror = (err) => {
            console.log("Error", err);
            if(this.errorCallback) {
                this.errorCallback(err)
            }
        }

        this.socket.onmessage = (event) => {
            let message = JSON.parse(event.data);
            if(this.messageCallback) {
                this.messageCallback(message);
            }
        }
    }

    send(data) {
        let message = JSON.stringify(data);

        this.waitForSocketConnection(() => {
            this.socket.send(message);
        }, 0);
    }

    waitForSocketConnection(callback, depth) {
        if (this.socket && this.socket.readyState === WebSocket.OPEN) {
            if (callback !== undefined) {
                callback();
            }
            return true
        } else {
            setTimeout(() => {
                if (this.socket && this.socket.readyState === WebSocket.OPEN) {
                    if (callback !== undefined) {
                        callback();
                    }
                    return true
                } else {
                    depth += 1;
                    if (depth < 15) {
                        console.log('Waiting for socket connection...')
                        this.waitForSocketConnection(callback, depth);
                    } else {
                        console.log("Cannot connect, try again later")
                        return
                    }
                }
            }, 1000);
        }
    }

    on(event, callback) {
        if(callback === undefined || typeof callback !== 'function') return;

        if(event === 'message') {
            this.messageCallback = callback;
        } else if (event === 'open') {
            this.openCallback = callback;
        } else if (event === 'close') {
            this.closeCallback = callback;
        } else if (event === 'error') {
            this.errorCallback = callback;
        }
    }

    reconnect() {
        setTimeout(() => {
            console.log(`Reconnecting to ${this.url}...`);
            this.connect();
        }, 2000)
    }

    disconnect() {
        if(this.socket) {
            this.stopReconnections = true;
            console.log(`Closing connection to ${this.url}`);
            this.socket.close(1000);
            this.socket = null;
        }
    }
}